module.exports = __webpack_public_path__ + "static/media/302.0545ecbd.svg";